import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SideMenuItem from './item';
import './side.css';
import { setMobileMenuVisibility } from '../../../reducers/infrastructure';
import { history } from '../../../configuration/store';

class SideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.isActive = this.isActive.bind(this);
    }

    isActive(item, location) {
        for (let i = 0; i < item.locations.length; i++) {
            if (item.locations[i] === location) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { admin, size, location, pages, menuVisible, setMobileMenuVisibility } = this.props;

        if (!admin) return null;
        const { name, logo_url, logo_height, logo_width } = admin;

        menuVisible === true ? document.body.classList.add('sidebar-active') : document.body.classList.remove('sidebar-active');
        return (
            <div className={`${size} side-menu-wrapper ${menuVisible === true ? 'active' : ''}`}>
                <div className="side-menu-underlay" onClick={() => setMobileMenuVisibility(false)} />
                <div className="side-menu">
                    <div className="side-menu-header visible-xs">
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="col-xs-1 mobile-menu-button" onClick={() => setMobileMenuVisibility(false)}>
                                    <i className="material-icons">close</i>
                                </div>
                                <div className="col-md-2 col-xs-5">
                                    <div className="logo no-select" onClick={() => history.push('/')}>
                                        {logo_url && logo_width && logo_height && <img src={logo_url} width={logo_width} height={logo_height} alt={name} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row side-menu-links">
                        {pages &&
                            pages.filter(p => p.hide !== true).map(
                                (item, index) =>
                                    item.blank ? (
                                        <div key={index} className="col-xs-12 blank-item" />
                                    ) : (
                                        <SideMenuItem
                                            key={index}
                                            {...{
                                                ...item,
                                                action: () => {
                                                    item.action();
                                                    setMobileMenuVisibility(false);
                                                }
                                            }}
                                            active={this.isActive(item, location)}
                                        />
                                    )
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

SideMenu.defaultProps = {
    isAuthenticated: false,
    size: '',
    location: '/'
};

SideMenu.propTypes = {
    isAuthenticated: PropTypes.bool,
    size: PropTypes.string,
    location: PropTypes.string
};

const mapStateToProps = state => ({
    isAuthenticated: state.identity.isAuthenticated,
    admin: state.users.adminDetails,
    location: state.routing.location.pathname,
    pages: state.tenants.menu,
    menuVisible: state.infrastructure.menuVisible
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setMobileMenuVisibility: setMobileMenuVisibility
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/components/menus/side/index.jsx